import { FilterOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { formatDate } from 'utils';

export const columns = [
  {
    title: 'Скидка',
    dataIndex: 'percent',
    key: 'percent',
    render: (value) => `${value}%`,
  },

  {
    title: 'Дата начала',
    dataIndex: 'start_at',
    key: 'start_at',
    render: (value) => formatDate(value),
  },
  {
    title: 'Дата окончание',
    dataIndex: 'end_at',
    key: 'end_at',
    render: (value) => formatDate(value),
  },
  {
    title: 'Статус',
    dataIndex: 'is_active',
    key: 'is_active',
    render: (value) => {
      const text = value ? 'Активный' : 'Не активный';
      const color = value ? 'green' : 'red';

      return <Tag color={color}>{text}</Tag>;
    },
    filters: [
      {
        text: 'Активный',
        value: true,
      },
      {
        text: 'Не активный',
        value: false,
      },
    ],
    onFilter: (value, record) => record.is_active === value,
    filterIcon: () => <FilterOutlined />,
  },
  {
    title: 'Дата создания',
    dataIndex: 'created_date',
    key: 'created_date',
    render: (value) => formatDate(value),
  },
];
